import React, { useState, useEffect, useRef } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

//STYLES
import * as ControllerStyles from "../styles/controller";

function FileNameSlot(props) {
    const ref = useRef(null);
    const [overflow, setOverflow] = useState(false);

    useEffect(() => {
        if (ref.current.scrollWidth > ref.current.offsetWidth) {
            setOverflow(true);
        } else {
            setOverflow(false);
        }
    }, [props]);

    return (
        <div style={ControllerStyles.fileNameSlot} ref={ref}>
            {overflow ? (
                <div>
                    <OverlayTrigger placement="bottom" overlay={<Tooltip>{props.name}</Tooltip>}>
                        <div style={ControllerStyles.fileNameSlot}>{props.name}</div>
                    </OverlayTrigger>
                </div>
            ) : (
                <div>{props.name}</div>
            )}
        </div>
    );
}

export default FileNameSlot;
